/* =============================================
   SONAMU Recipe Interactive Features v2
   ============================================= */

document.addEventListener('DOMContentLoaded', function() {

  // =============================================
  // 1. ZUTATEN-CHECKBOXEN (Abhaken was man hat)
  // =============================================
  const ingredientSection = document.getElementById('ingredient');
  if (ingredientSection) {
    const items = ingredientSection.querySelectorAll('li');
    const recipeId = window.location.pathname;
    const saved = JSON.parse(localStorage.getItem('sonamu-checked-' + recipeId) || '{}');

    items.forEach(function(item, index) {
      item.style.cursor = 'pointer';
      item.style.transition = 'opacity 0.3s ease';

      // Add checkbox at the end instead of beginning (no position shift)
      const checkbox = document.createElement('span');
      checkbox.style.cssText = 'display:inline-block;width:18px;height:18px;border:2px solid #151515;margin-right:10px;vertical-align:middle;text-align:center;line-height:14px;font-size:12px;flex-shrink:0;transition:all 0.2s ease;';

      if (saved[index]) {
        checkbox.textContent = '✓';
        checkbox.style.backgroundColor = '#151515';
        checkbox.style.color = '#fff';
        item.style.opacity = '0.4';
        item.style.textDecoration = 'line-through';
      }

      item.insertBefore(checkbox, item.firstChild);

      item.addEventListener('click', function() {
        const isChecked = checkbox.textContent === '✓';
        if (isChecked) {
          checkbox.textContent = '';
          checkbox.style.backgroundColor = 'transparent';
          checkbox.style.color = '#151515';
          item.style.opacity = '1';
          item.style.textDecoration = 'none';
          delete saved[index];
        } else {
          checkbox.textContent = '✓';
          checkbox.style.backgroundColor = '#151515';
          checkbox.style.color = '#fff';
          item.style.opacity = '0.4';
          item.style.textDecoration = 'line-through';
          saved[index] = true;
        }
        localStorage.setItem('sonamu-checked-' + recipeId, JSON.stringify(saved));
        updateCheckedCounter();
      });
    });

    // Counter
    const counter = document.createElement('div');
    counter.id = 'ingredient-counter';
    counter.style.cssText = 'font-family:Archivo,sans-serif;font-size:14px;color:#656E6E;margin-bottom:16px;';
    const subheading = ingredientSection.querySelector('.subheading');
    if (subheading) {
      subheading.insertAdjacentElement('afterend', counter);
    }

    function updateCheckedCounter() {
      const total = items.length;
      const checked = Object.keys(saved).length;
      if (checked === 0) {
        counter.textContent = 'Tippe auf Zutaten um sie abzuhaken';
      } else if (checked === total) {
        counter.textContent = '✓ Alle ' + total + ' Zutaten abgehakt!';
        counter.style.color = '#151515';
        counter.style.fontWeight = '600';
      } else {
        counter.textContent = checked + ' von ' + total + ' Zutaten abgehakt';
      }
    }
    updateCheckedCounter();

    // Reset button
    const resetBtn = document.createElement('button');
    resetBtn.textContent = 'ZURÜCKSETZEN';
    resetBtn.style.cssText = 'font-family:Archivo,sans-serif;font-size:11px;letter-spacing:0.08em;background:none;border:1px solid #ccc;padding:6px 14px;cursor:pointer;margin-top:16px;text-transform:uppercase;color:#656E6E;transition:all 0.2s ease;';
    resetBtn.addEventListener('mouseenter', function() { this.style.borderColor = '#151515'; this.style.color = '#151515'; });
    resetBtn.addEventListener('mouseleave', function() { this.style.borderColor = '#ccc'; this.style.color = '#656E6E'; });
    resetBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      items.forEach(function(item) {
        const cb = item.querySelector('span');
        if (cb) {
          cb.textContent = '';
          cb.style.backgroundColor = 'transparent';
        }
        item.style.opacity = '1';
        item.style.textDecoration = 'none';
      });
      Object.keys(saved).forEach(function(k) { delete saved[k]; });
      localStorage.setItem('sonamu-checked-' + recipeId, JSON.stringify(saved));
      counter.style.color = '#656E6E';
      counter.style.fontWeight = '400';
      updateCheckedCounter();
    });
    ingredientSection.querySelector('.body-text').appendChild(resetBtn);
  }


  // =============================================
  // 2. "HAB ICH GEKOCHT" + BEWERTUNG
  // =============================================
  const contentBody = document.querySelector('.recipe-content-body');
  if (contentBody) {
    const recipeId = window.location.pathname;
    const recipeTitle = document.querySelector('.article__title') ? document.querySelector('.article__title').textContent : '';
    const reviewKey = 'sonamu-reviews';
    const allReviews = JSON.parse(localStorage.getItem(reviewKey) || '{}');
    const existingReview = allReviews[recipeId];

    const cookedSection = document.createElement('div');
    cookedSection.style.cssText = 'text-align:center;padding:40px 0;margin-top:30px;border-top:1px solid #e5e5e5;';

    if (existingReview) {
      // Show existing review
      cookedSection.innerHTML = '<div style="font-family:Archivo,sans-serif;">' +
        '<div style="font-size:24px;margin-bottom:8px;">' + '★'.repeat(existingReview.stars) + '☆'.repeat(5 - existingReview.stars) + '</div>' +
        '<div style="font-size:13px;color:#656E6E;text-transform:uppercase;letter-spacing:0.06em;">Deine Bewertung</div>' +
        (existingReview.text ? '<div style="font-size:15px;margin-top:12px;color:#333;font-style:italic;">"' + existingReview.text + '"</div>' : '') +
        '</div>';
    } else {
      // Show "Hab ich gekocht" button
      const cookedBtn = document.createElement('button');
      cookedBtn.textContent = 'HAB ICH GEKOCHT';
      cookedBtn.style.cssText = 'font-family:Archivo,sans-serif;font-size:14px;letter-spacing:0.08em;padding:14px 32px;cursor:pointer;text-transform:uppercase;transition:all 0.3s ease;border:2px solid #151515;background:#fff;color:#151515;';
      cookedBtn.addEventListener('mouseenter', function() { this.style.background = '#151515'; this.style.color = '#fff'; });
      cookedBtn.addEventListener('mouseleave', function() { this.style.background = '#fff'; this.style.color = '#151515'; });

      cookedBtn.addEventListener('click', function() {
        // Replace button with rating form
        cookedSection.innerHTML = '';
        cookedSection.style.textAlign = 'center';

        // Title
        const title = document.createElement('div');
        title.textContent = 'WIE WARS?';
        title.style.cssText = 'font-family:Archivo,sans-serif;font-size:14px;letter-spacing:0.08em;text-transform:uppercase;margin-bottom:20px;font-weight:600;';
        cookedSection.appendChild(title);

        // Stars
        const starsDiv = document.createElement('div');
        starsDiv.style.cssText = 'font-size:36px;cursor:pointer;margin-bottom:20px;';
        let selectedStars = 0;

        for (let i = 1; i <= 5; i++) {
          const star = document.createElement('span');
          star.textContent = '☆';
          star.dataset.value = i;
          star.style.cssText = 'transition:all 0.1s ease;padding:0 2px;';

          star.addEventListener('mouseenter', function() {
            for (let j = 0; j < 5; j++) {
              starsDiv.children[j].textContent = j < i ? '★' : '☆';
            }
          });

          star.addEventListener('click', function() {
            selectedStars = i;
            for (let j = 0; j < 5; j++) {
              starsDiv.children[j].textContent = j < i ? '★' : '☆';
            }
          });

          starsDiv.appendChild(star);
        }

        starsDiv.addEventListener('mouseleave', function() {
          for (let j = 0; j < 5; j++) {
            starsDiv.children[j].textContent = j < selectedStars ? '★' : '☆';
          }
        });

        cookedSection.appendChild(starsDiv);

        // Comment field
        const textarea = document.createElement('textarea');
        textarea.placeholder = 'Was hat dir gefallen? Was würdest du ändern? (optional)';
        textarea.style.cssText = 'font-family:Archivo,sans-serif;font-size:14px;width:100%;max-width:400px;height:80px;border:1px solid #ccc;padding:12px;resize:none;display:block;margin:0 auto 16px auto;outline:none;transition:border-color 0.2s;';
        textarea.addEventListener('focus', function() { this.style.borderColor = '#151515'; });
        textarea.addEventListener('blur', function() { this.style.borderColor = '#ccc'; });
        cookedSection.appendChild(textarea);

        // Submit button
        const submitBtn = document.createElement('button');
        submitBtn.textContent = 'BEWERTUNG ABGEBEN';
        submitBtn.style.cssText = 'font-family:Archivo,sans-serif;font-size:13px;letter-spacing:0.08em;padding:12px 28px;cursor:pointer;text-transform:uppercase;border:none;background:#151515;color:#fff;transition:background 0.2s ease;';
        submitBtn.addEventListener('mouseenter', function() { this.style.background = '#FF4202'; });
        submitBtn.addEventListener('mouseleave', function() { this.style.background = '#151515'; });

        submitBtn.addEventListener('click', function() {
          if (selectedStars === 0) {
            title.textContent = 'BITTE MINDESTENS 1 STERN';
            title.style.color = '#FF4202';
            setTimeout(function() { title.textContent = 'WIE WARS?'; title.style.color = '#151515'; }, 2000);
            return;
          }

          const review = {
            stars: selectedStars,
            text: textarea.value.trim(),
            date: new Date().toISOString(),
            recipe: recipeTitle
          };

          allReviews[recipeId] = review;
          localStorage.setItem(reviewKey, JSON.stringify(allReviews));

          // Show thank you
          cookedSection.innerHTML = '<div style="font-family:Archivo,sans-serif;">' +
            '<div style="font-size:24px;margin-bottom:8px;">' + '★'.repeat(selectedStars) + '☆'.repeat(5 - selectedStars) + '</div>' +
            '<div style="font-size:14px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;margin-bottom:8px;">DANKE FÜR DEINE BEWERTUNG!</div>' +
            (review.text ? '<div style="font-size:15px;color:#333;font-style:italic;">"' + review.text + '"</div>' : '') +
            '</div>';
        });

        cookedSection.appendChild(submitBtn);
      });

      cookedSection.appendChild(cookedBtn);
    }

    contentBody.appendChild(cookedSection);
  }


  // =============================================
  // 3. DRUCKEN BUTTON
  // =============================================
  const jumpContainer = document.querySelector('.recipe-jump-container');
  if (jumpContainer) {
    const printBtn = document.createElement('a');
    printBtn.textContent = 'DRUCKEN';
    printBtn.href = '#';
    printBtn.className = 'recipe-jump-button';
    printBtn.addEventListener('click', function(e) {
      e.preventDefault();
      window.print();
    });
    jumpContainer.appendChild(printBtn);
  }

});



  // =============================================
  // 4. PORTIONSRECHNER
  // =============================================
  var infoBox = document.querySelector('.recipe-info-box');
  var ingredientSection = document.getElementById('ingredient');
  if (infoBox && ingredientSection) {
    // Finde Personen-Feld in der Info-Box
    var infoItems = infoBox.querySelectorAll('.info-item');
    var personenItem = null;
    var baseServings = 2;

    infoItems.forEach(function(item) {
      var label = item.querySelector('strong');
      if (label && label.textContent.trim() === 'PERSONEN') {
        personenItem = item;
        var val = item.querySelector('span');
        if (val) {
          var num = parseInt(val.textContent);
          if (!isNaN(num)) baseServings = num;
        }
      }
    });

    if (personenItem) {
      // Ersetze statische Zahl durch +/- Buttons
      var spanEl = personenItem.querySelector('span');
      if (spanEl) {
        var currentServings = baseServings;

        var wrapper = document.createElement('div');
        wrapper.style.cssText = 'display:flex;align-items:center;gap:8px;justify-content:center;margin-top:4px;';

        var minusBtn = document.createElement('button');
        minusBtn.textContent = '−';
        minusBtn.style.cssText = 'width:28px;height:28px;border:1px solid #151515;background:#fff;color:#151515;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;line-height:1;font-family:Archivo,sans-serif;';

        var display = document.createElement('span');
        display.textContent = currentServings;
        display.style.cssText = 'font-size:16px;min-width:20px;text-align:center;font-family:Archivo,sans-serif;';

        var plusBtn = document.createElement('button');
        plusBtn.textContent = '+';
        plusBtn.style.cssText = minusBtn.style.cssText;

        wrapper.appendChild(minusBtn);
        wrapper.appendChild(display);
        wrapper.appendChild(plusBtn);

        spanEl.textContent = '';
        spanEl.appendChild(wrapper);

        // Parse Zutaten-Mengen
        var items = ingredientSection.querySelectorAll('li');
        var originalTexts = [];
        items.forEach(function(item) {
          // Text ohne Checkbox
          var text = '';
          item.childNodes.forEach(function(node) {
            if (node.nodeType === 3) text += node.textContent;
            else if (node.tagName !== 'SPAN' || !node.style.cssText.includes('width:18px')) {
              text += node.textContent;
            }
          });
          originalTexts.push(text.trim());
        });

        function updateServings(newVal) {
          if (newVal < 1 || newVal > 20) return;
          var ratio = newVal / baseServings;
          currentServings = newVal;
          display.textContent = currentServings;

          items.forEach(function(item, idx) {
            var original = originalTexts[idx];
            // Finde Zahlen am Anfang (z.B. "300 g", "2 EL", "1/2")
            var updated = original.replace(/^(\d+([.,]\d+)?)\s/, function(match, num) {
              var parsed = parseFloat(num.replace(',', '.'));
              var scaled = Math.round(parsed * ratio * 10) / 10;
              var formatted = scaled % 1 === 0 ? scaled.toString() : scaled.toFixed(1).replace('.', ',');
              return formatted + ' ';
            });

            // Update nur den Text, nicht die Checkbox
            var textNodes = [];
            item.childNodes.forEach(function(node) {
              if (node.nodeType === 3) textNodes.push(node);
            });
            if (textNodes.length > 0) {
              textNodes[textNodes.length - 1].textContent = updated;
            }
          });
        }

        minusBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          updateServings(currentServings - 1);
        });
        plusBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          updateServings(currentServings + 1);
        });
      }
    }
  }


  // =============================================
  // 5. KOCH-TIMER
  // =============================================
  if (infoBox) {
    var kochzeitItem = null;
    var infoItemsAll = infoBox.querySelectorAll('.info-item');
    infoItemsAll.forEach(function(item) {
      var label = item.querySelector('strong');
      if (label && label.textContent.trim() === 'KOCHZEIT') {
        kochzeitItem = item;
      }
    });

    if (kochzeitItem) {
      var kochzeitSpan = kochzeitItem.querySelector('span');
      var kochzeitText = kochzeitSpan ? kochzeitSpan.textContent.trim() : '';
      var minutes = parseInt(kochzeitText);

      if (!isNaN(minutes) && minutes > 0) {
        var timerBtn = document.createElement('button');
        timerBtn.textContent = 'TIMER STARTEN';
        timerBtn.style.cssText = 'display:block;margin:8px auto 0;font-family:Archivo,sans-serif;font-size:10px;letter-spacing:0.08em;padding:4px 12px;border:1px solid #999;background:#fff;color:#656E6E;cursor:pointer;text-transform:uppercase;transition:all 0.2s;';
        timerBtn.addEventListener('mouseenter', function() { this.style.borderColor='#151515'; this.style.color='#151515'; });
        timerBtn.addEventListener('mouseleave', function() { if (!timerRunning) { this.style.borderColor='#999'; this.style.color='#656E6E'; }});

        var timerDisplay = document.createElement('div');
        timerDisplay.style.cssText = 'font-family:Archivo,sans-serif;font-size:24px;font-weight:600;text-align:center;margin-top:8px;display:none;color:#151515;';

        kochzeitItem.appendChild(timerBtn);
        kochzeitItem.appendChild(timerDisplay);

        var timerRunning = false;
        var timerInterval = null;
        var remainingSeconds = 0;

        function formatTime(secs) {
          var m = Math.floor(secs / 60);
          var s = secs % 60;
          return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        }

        timerBtn.addEventListener('click', function() {
          if (!timerRunning) {
            // Start
            remainingSeconds = minutes * 60;
            timerDisplay.style.display = 'block';
            timerDisplay.textContent = formatTime(remainingSeconds);
            timerBtn.textContent = 'STOP';
            timerBtn.style.borderColor = '#FF4202';
            timerBtn.style.color = '#FF4202';
            timerRunning = true;

            timerInterval = setInterval(function() {
              remainingSeconds--;
              timerDisplay.textContent = formatTime(remainingSeconds);

              if (remainingSeconds <= 0) {
                clearInterval(timerInterval);
                timerRunning = false;
                timerDisplay.textContent = 'FERTIG!';
                timerDisplay.style.color = '#FF4202';
                timerBtn.textContent = 'NOCHMAL';
                timerBtn.style.borderColor = '#151515';
                timerBtn.style.color = '#151515';

                // Sound/Vibration wenn verfügbar
                if ('vibrate' in navigator) navigator.vibrate([200, 100, 200]);
                try { new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJGrl5BzbWV0teleT0JQZHqMiHlndnOGq4yBfYuNh4CSlpiYk4eLjZGTiYOIiomHgn+DiI6Hf4eMj4mFhYqIh4SHiouLhIWLjIiDhIyNiYWIiYiGhYeJiIaFh4qJhoaIiYeGhomIh4aHiYmHhoeIiIaHh4iIh4eHiIiHh4eIiIeHh4iHh4eHiIeHh4eIh4eHh4iHhw==').play(); } catch(e) {}
              }
            }, 1000);
          } else {
            // Stop
            clearInterval(timerInterval);
            timerRunning = false;
            timerDisplay.style.display = 'none';
            timerBtn.textContent = 'TIMER STARTEN';
            timerBtn.style.borderColor = '#999';
            timerBtn.style.color = '#656E6E';
            timerDisplay.style.color = '#151515';
          }
        });
      }
    }
  }
